<div class="w-full max-w-md px-8 py-6 !rounded-[8px] bg-white shadow-lg">
  <div class="flex items-start justify-between gap-4">
    <div class="flex items-start gap-4">
      <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full" [ngClass]="iconBgClass">
        <mat-icon *ngIf="icon as i" [ngClass]="iconClass" class="text-2xl leading-none">{{ i }}</mat-icon>
      </div>

      <div class="min-w-0">
        <h2 class="text-xl font-semibold text-gray-900">
          {{ data.title }}
        </h2>

        <p class="mt-2 text-sm leading-relaxed text-gray-600 whitespace-pre-line">
          {{ data.message }}
        </p>
      </div>
    </div>

    <button
      type="button"
      mat-icon-button
      (click)="cancel()"
      class="text-gray-400 hover:text-gray-600 transition-colors duration-150"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="mt-7 flex flex-row justify-end gap-3">
    <button
      *ngIf="showCancel"
      mat-stroked-button
      type="button"
      (click)="cancel()"
      class="rounded-full border border-gray-300 bg-white px-6 py-2 text-sm font-medium text-gray-700 transition-colors duration-150 hover:bg-gray-50"
    >
      {{ cancelText }}
    </button>

    <button
      mat-stroked-button
      type="button"
      (click)="confirm()"
      class="rounded-full border bg-white px-6 py-2 text-sm font-medium transition-colors duration-150"
      [ngClass]="confirmButtonClass"
    >
      {{ confirmText }}
    </button>
  </div>
</div>
